import { CurrencyInfo } from "./Types";

export const AUTH_API_KEY: string = "TripBooker";
export const JWT_API_KEY: string = "Bearer";
export const SUCCESS: string = "Success";
//localhost:8080/?token=3Ct5%2bYjcC1q1H3OSPmDEEQklAzHOUoWZzTwTN2%2f5a88ToQm%2b2Asu0OVr%2bYULv9ixiq5i1
export const AUTH_TOKEN_REGEX = /[?&]token=([^&|$]*)/;
//http://localhost:8080/quote/9ac6dcbe-dccd-4147-9527-d7b1fa106b03
export const SALESFORCE_INTERGRATION_USER_MAIL = "sfintegration.user@ef.com";

export const UPSELL_ACTIVATION_DATE = "2023-11-16";
export const MAX_DURATION_FOR_UPGRADE_WEEKS = 16;
export const SINGLE_WEEK_DURATION = 1;
export const MULTI_WEEK_DURATION_THRESHOLD = 4;
export const SINGLE_MANDATORY_ACCOMMODATION_COUNT = 1;
export const IMAGE_CARD_ASPECT_RATIO = "3/2";

export const RECURRING_PAYMENT_ALLOWED_ABOVE_DAYS = 60;
export const SPLIT_PAYMENT_ALLOWED_ABOVE_DAYS = 7;
// Used instead of SPLIT_PAYMENT_ALLOWED_ABOVE_DAYS in markets with the hideSplitPaymentWithin30Days flag (RLT-7024)
export const LATE_BOOKING_SPLIT_PAYMENT_ALLOWED_ABOVE_DAYS = 30;

export const AdyenResultCodes = {
  AuthenticationFinished: "AuthenticationFinished",
  AuthenticationNotRequired: "AuthenticationNotRequired",
  Authorised: "Authorised",
  Cancelled: "Cancelled",
  ChallengeShopper: "ChallengeShopper",
  Error: "Error",
  IdentifyShopper: "IdentifyShopper",
  Pending: "Pending",
  PresentToShopper: "PresentToShopper",
  Received: "Received",
  RedirectShopper: "RedirectShopper",
  Refused: "Refused",
};

export const PAY_BY_BANK_PAYMENT_METHOD_TYPE = "paybybank";

export const TRUE: string = "true";
export const TOOLTIP_CLOSE_DELAY_MS = 150;

// eslint-disable-next-line prettier/prettier
export const SUPPORTED_PAYMENT_COUNTRY_CODES = new Set([
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AN",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW",
]);

export const CURRENCY_MAPPING: Array<CurrencyInfo> = [
  {
    currencyCode: "AED",
    currencySymbol: "د.إ",
    displayPosition: "after",
  },
  {
    currencyCode: "ANG",
    currencySymbol: "NAf",
    displayPosition: "after",
  },
  {
    currencyCode: "ARA",
    currencySymbol: "₳",
    displayPosition: "after",
  },
  {
    currencyCode: "ARS",
    currencySymbol: "ARS",
    displayPosition: "before",
  },
  {
    currencyCode: "AUD",
    currencySymbol: "A$",
    displayPosition: "before",
  },
  {
    currencyCode: "BND",
    currencySymbol: "B$",
    displayPosition: "before",
  },
  {
    currencyCode: "BRL",
    currencySymbol: "R$",
    displayPosition: "before",
  },
  {
    currencyCode: "CAD",
    currencySymbol: "CA$",
    displayPosition: "after",
  },
  {
    currencyCode: "CHF",
    currencySymbol: "Fr.",
    displayPosition: "after",
  },
  {
    currencyCode: "CLP",
    currencySymbol: "CLP $",
    displayPosition: "before",
  },
  {
    currencyCode: "COP",
    currencySymbol: "COL$",
    displayPosition: "before",
  },
  {
    currencyCode: "CRC",
    currencySymbol: "₡",
    displayPosition: "after",
  },
  {
    currencyCode: "CZK",
    currencySymbol: "Kč",
    displayPosition: "after",
  },
  {
    currencyCode: "DKK",
    currencySymbol: "Kr.",
    displayPosition: "after",
  },
  {
    currencyCode: "DZD",
    currencySymbol: "DZD",
    displayPosition: "after",
  },
  {
    currencyCode: "ECS",
    currencySymbol: "S/.",
    displayPosition: "after",
  },
  {
    currencyCode: "ESP",
    currencySymbol: "Pt",
    displayPosition: "after",
  },
  {
    currencyCode: "EUR",
    currencySymbol: "€",
    displayPosition: "after",
  },
  {
    currencyCode: "GBP",
    currencySymbol: "£",
    displayPosition: "before",
  },
  {
    currencyCode: "HKD",
    currencySymbol: "HK$",
    displayPosition: "after",
  },
  {
    currencyCode: "HUF",
    currencySymbol: "Ft",
    displayPosition: "after",
  },
  {
    currencyCode: "IRR",
    currencySymbol: "﷼",
    displayPosition: "after",
  },
  {
    currencyCode: "JPY",
    currencySymbol: "¥",
    displayPosition: "before",
    noFractionalUnits: true,
  },
  {
    currencyCode: "KRW",
    currencySymbol: "₩",
    displayPosition: "after",
  },
  {
    currencyCode: "KZT",
    currencySymbol: "₸",
    displayPosition: "after",
  },
  {
    currencyCode: "LYD",
    currencySymbol: "LD",
    displayPosition: "after",
  },
  {
    currencyCode: "MXN",
    currencySymbol: "MX$",
    displayPosition: "before",
  },
  {
    currencyCode: "MXP",
    currencySymbol: "MX$",
    displayPosition: "before",
  },
  {
    currencyCode: "NLG",
    currencySymbol: "fl.",
    displayPosition: "after",
  },
  {
    currencyCode: "NOK",
    currencySymbol: "kr",
    displayPosition: "after",
  },
  {
    currencyCode: "NZD",
    currencySymbol: "NZ$",
    displayPosition: "before",
  },
  {
    currencyCode: "PAB",
    currencySymbol: "B/.",
    displayPosition: "after",
  },
  {
    currencyCode: "PEN",
    currencySymbol: "S/",
    displayPosition: "after",
  },
  {
    currencyCode: "PLN",
    currencySymbol: "zł",
    displayPosition: "after",
  },
  {
    currencyCode: "RUB",
    currencySymbol: "₽",
    displayPosition: "after",
  },
  {
    currencyCode: "SAR",
    currencySymbol: "SR",
    displayPosition: "after",
  },
  {
    currencyCode: "SEK",
    currencySymbol: "kr",
    displayPosition: "after",
  },
  {
    currencyCode: "SGD",
    currencySymbol: "S$",
    displayPosition: "before",
  },
  {
    currencyCode: "TND",
    currencySymbol: "DT",
    displayPosition: "after",
  },
  {
    currencyCode: "TRY",
    currencySymbol: "₺",
    displayPosition: "after",
  },
  {
    currencyCode: "TWD",
    currencySymbol: "NT$",
    displayPosition: "before",
  },
  {
    currencyCode: "USD",
    currencySymbol: "US$",
    displayPosition: "before",
  },
  {
    currencyCode: "UYP",
    currencySymbol: "$U",
    displayPosition: "before",
  },
  {
    currencyCode: "VEB",
    currencySymbol: "Bs",
    displayPosition: "after",
  },
  {
    currencyCode: "ZAR",
    currencySymbol: "R",
    displayPosition: "after",
  },
];
